import { render, staticRenderFns } from "./workList.vue?vue&type=template&id=4c889964&scoped=true"
import script from "./workList.vue?vue&type=script&lang=js"
export * from "./workList.vue?vue&type=script&lang=js"
import style0 from "./workList.vue?vue&type=style&index=0&id=4c889964&scoped=true&lang=scss"
import style1 from "./workList.vue?vue&type=style&index=1&id=4c889964&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c889964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c889964')) {
      api.createRecord('4c889964', component.options)
    } else {
      api.reload('4c889964', component.options)
    }
    module.hot.accept("./workList.vue?vue&type=template&id=4c889964&scoped=true", function () {
      api.rerender('4c889964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pygame/components/workList.vue"
export default component.exports